import { get } from './http-methods';

export default {
  async getUserRoles() {
    try {
      const response = await get('/users/roles');
      return response.json.data;
    } catch (error) {
      console.error('[getUserRoles][error]:', error);
    }
  },
  async getUserCountries() {
    try {
      const response = await get('/users/countries');
      return response.json.data;
    } catch (error) {
      console.error('[getUserCountries][error]:', error);
    }
  },
};
